export default "__VITE_ASSET__S4h_Yf5A__"